import React from "react";
import { Core } from "../../components/infrastructure/core";
import { enmValidationLevel, IResultSet } from "../../components/infrastructure/models";
import { Alert, Button, Form, Input, Radio, Tooltip } from "antd";
import { InfoCircleFilled, QuestionCircleFilled } from '@ant-design/icons';
import { Captcha } from "../../components/captcha";

interface RegisterSerialOrIMEIStates {
    loading: boolean;
    equipmentType: "Mobile" | "Other";
    done?: boolean;
    captcha: string;
}

interface RegisterSerialOrIMEIProps {
    nationalCode: string;
    captcha: string;
    onRegistered: (captcha: string) => void;
    onReturn: () => void;
}


export const RegisterSerialOrIMEI = (props: RegisterSerialOrIMEIProps) => {
    const [state, setState] = React.useState<RegisterSerialOrIMEIStates>({ loading: false, equipmentType: "Mobile", captcha: props.captcha });
    const [form] = Form.useForm();
    const componentWillUnmount = React.useRef(false);

    const back = async () => {
        let response = await fetch("api/userpolicyholder/logoutpolicyholderextraaccess", {
            method: 'POST',
            headers: { 'content-type': 'application/json;charset=UTF-8' }
        });
        await response.json();
        props.onReturn();
    };

    const inquiry = async (values: any) => {
        if (state.loading)
            return;

        const imei1 = values['imei1'];
        const imei2 = values['imei2'];
        const equipmentSerialNo = values['equipmentSerialNo'];

        if (!equipmentSerialNo && !imei1 && !imei2) {
            Core.errorNotification('حداقل یکی از ورودی های IMEI1 یا IMEI2 اجباری است');
            return;
        }

        setState({ ...state, loading: true });

        let response = await fetch("api/userpolicyholder/registerserialorimei", {
            method: 'POST',
            body: JSON.stringify({
                nationalCode: props.nationalCode,
                isMobile: state.equipmentType === "Mobile",
                imei1: state.equipmentType === "Mobile" ? values['imei1'] ?? null : null,
                imei2: state.equipmentType === "Mobile" ? values['imei2'] ?? null : null,
                equipmentSerialNo: state.equipmentType === "Other" ? values['equipmentSerialNo'] ?? null : null,
                captcha: values['captcha'] ?? state.captcha
            }),
            headers: { 'content-type': 'application/json;charset=UTF-8' }
        });

        if (componentWillUnmount.current === true)
            return;

        let result: IResultSet<string> = await response.json();

        if (!result.ValidationState.Successful) {
            if (result.ValidationState.ValidationResults.find(v => [enmValidationLevel.Unauthorized, enmValidationLevel.AccessDenied].indexOf(v.Level) > -1)) {
                Core.errorNotification(result.ValidationState.ValidationResults[0].Message!);
                props.onReturn();
                return;
            }
            Core.errorNotification(result.ValidationState.ValidationResults[0].Message);
            setState({ ...state, loading: false, captcha: '' });
        }
        else {
            Core.successNotification("استعلام با موفقیت انجام شد، لطفاً کلمه عبور یکبار مصرف را درخواست نمایید");
            props.onRegistered(values['captcha'] ?? state.captcha);
        }
    };

    React.useEffect(() => {
        return () => {
            componentWillUnmount.current = true;
        };
    }, []);

    const mobileFieldsStyle = state.equipmentType === "Mobile" ? {} : { display: "none" };
    const otherFieldsStyle = state.equipmentType === "Mobile" ? { display: "none" } : {};

    return (

        <Form
            form={form}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            name="normal_login"
            className=" login-form col-sm-8 col-md-6 col-lg-6 col-xl-4 col-xs-8 "
            initialValues={{ remember: true }}
            onFinish={inquiry}
            onReset={back}
            style={{ width: "calc(100% - 20px)", height: "100%", textAlign: 'right', margin: 10 }}
        >
            <div className="box box-blue" style={{ backgroundColor: "#fefefe90", border: "1px solid white", borderRadius: 15 }}>
                <div className="box-title" style={{ border: "1px solid white", borderTopLeftRadius: 15, borderTopRightRadius: 15 }}>
                    <div className="caption">استعلام سریال یا IMEI</div>
                </div>

                <div className="box-body form" style={{ border: "1px solid white", borderRadius: 15 }}>
                    <div className="form-body">

                        <Alert
                            style={{ marginTop: 10, marginBottom: 20, textAlign: 'justify' }}
                            message={"بیمه گزار/مشتری گرامی، لطفا سریال دستگاه یا IMEI را وارد نمایید."}
                            type="info"
                            icon={<InfoCircleFilled className="blink" />}
                            showIcon
                        />

                        <Radio.Group key={'equipmentType'} style={{ marginBottom: 10 }} onChange={e => setState({ ...state, equipmentType: e.target.value })} value={state.equipmentType}>
                            <Radio key={'mobile'} value={"Mobile"}>
                                <div>
                                    <span>ثبت دستگاه موبایل</span>

                                </div>
                            </Radio>
                            <Radio key={'other'} value={"Other"}>
                                <div>
                                    <span>ثبت دستگاه غیر موبایل</span>

                                </div>
                            </Radio>
                        </Radio.Group>

                        <Form.Item
                            name="imei1"
                            label="سریال IMEI1"
                            style={mobileFieldsStyle}
                            extra={
                                <Tooltip title="با وارد کردن کد USSD *#06# و یا برچسب روی جلد گوشی همراه خود شماره سریال IMEI1 را با دقت وارد نمایید" placement={"right"}>
                                    <Button icon={<QuestionCircleFilled style={{ transform: "scaleX(-1)" }} />} style={{ marginRight: 1, verticalAlign: 'top', position: "absolute", top: 0, left: 0, minHeight: 0 }} />
                                </Tooltip>
                            }
                        >
                            <Input
                                autoComplete="off"
                                placeholder="سریال IMEI1 دستگاه موبایل"
                            />
                        </Form.Item>

                        <Form.Item
                            name="imei2"
                            label="سریال IMEI2"
                            style={mobileFieldsStyle}
                            extra={
                                <Tooltip title="با وارد کردن کد USSD *#06# و یا برچسب روی جلد گوشی همراه خود شماره سریال IMEI2 را با دقت وارد نمایید" placement={"right"}>
                                    <Button icon={<QuestionCircleFilled style={{ transform: "scaleX(-1)" }} />} style={{ marginRight: 1, verticalAlign: 'top', position: "absolute", top: 0, left: 0, minHeight: 0 }} />
                                </Tooltip>
                            }
                        >
                            <Input
                                autoComplete="off"
                                placeholder="سریال IMEI2 دستگاه موبایل"
                            />
                        </Form.Item>

                        <Form.Item
                            name="equipmentSerialNo"
                            label="سریال دستگاه"
                            extra={
                                <Tooltip title="سریال دستگاه غیر موبایل" placement={"right"}>
                                    <Button icon={<QuestionCircleFilled style={{ transform: "scaleX(-1)" }} />} style={{ marginRight: 1, verticalAlign: 'top', position: "absolute", top: 0, left: 0, minHeight: 0 }} />
                                </Tooltip>
                            }
                            style={otherFieldsStyle}
                        >
                            <Input
                                autoComplete="off"
                                placeholder="سریال دستگاه غیر موبایل"
                            />
                        </Form.Item>

                        {(!state.loading && !state.captcha) &&
                            <Captcha
                                showLabel
                                form={form}
                                name="captcha"
                                label="متن تصویر"
                            />
                        }

                        <Form.Item
                            style={{ direction: 'ltr', textAlign: 'justify', marginTop: 10 }}
                        >
                            <Button type="primary" htmlType="submit" className="login-form-button" loading={state.loading}>
                                ادامه
                            </Button>
                            <Button type="default" htmlType="reset" className="login-form-button" loading={state.loading}>
                                لغو
                            </Button>
                        </Form.Item>
                    </div>
                </div>
            </div>

        </Form>
    );
}